import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import EmailVerificationModal from './EmailVerificationModal';
import ProfileIncompleteAlert from './ProfileIncompleteAlert';
import api from '../services/api';

const EmployerGuard = ({ children, requireEmailVerification = false, requireProfile = false }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showProfileAlert, setShowProfileAlert] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasProfile, setHasProfile] = useState(false);

  useEffect(() => {
    checkRequirements();
  }, [user, location.pathname]);

  const checkRequirements = async () => {
    if (!user || user.role !== 'employer') {
      setLoading(false);
      return;
    }

    // Check email verification
    if (requireEmailVerification && !user.isEmailVerified) {
      setShowEmailModal(true);
      setLoading(false);
      return;
    }

    // Check profile completion
    if (requireProfile) {
      try {
        const response = await api.get('/employer/company');
        setHasProfile(!!response.data);

        if (!response.data) {
          setShowProfileAlert(true);
        }
      } catch (error) {
        if (error.code === 'PROFILE_INCOMPLETE' || error.requiresProfileCreation) {
          setShowProfileAlert(true);
        }
      }
    }

    setLoading(false);
  };

  const handleEmailVerified = () => {
    setShowEmailModal(false);
    // Update user in context
    const updatedUser = { ...user, isEmailVerified: true };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    window.location.reload(); // Reload to update context
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh'
      }}>
        <div className="spinner-large"></div>
      </div>
    );
  }

  // Show email verification modal - block access to page
  if (showEmailModal && requireEmailVerification && !user.isEmailVerified) {
    return (
      <div className="employer-page">
        <div className="verification-required-container">
          <EmailVerificationModal
            isOpen={showEmailModal}
            onClose={() => navigate('/employer/dashboard')}
            onVerified={handleEmailVerified}
          />
        </div>
      </div>
    );
  }

  // Show profile incomplete alert
  if (showProfileAlert && requireProfile && !hasProfile) {
    return <ProfileIncompleteAlert />;
  }

  return <>{children}</>;
};

export default EmployerGuard;
